module.exports = __webpack_public_path__ + "fb5485aa8a7ca84041b270b2486fda0b.svg";